import { BodyText } from '@/utils/global-fonts';
import styled from 'styled-components';

const Radio = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  margin: calc(0.75em - 11px) 0.25rem 0 0;
  border: 2.5px solid #fff;
  outline: 1px solid ${({ theme }) => theme.COLOR_GREY2};
  border-radius: 50%;
  background: #fff no-repeat center center;
  cursor: pointer;
  &:checked {
    background: ${({ theme }) => theme.COLOR_BLACK} no-repeat center center;
    outline: 3px solid ${({ theme }) => theme.COLOR_BLACK};
  }
`;

const Flex = styled.div`
  display: flex;
`;

const RadioContainer = styled.label`
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  margin-right: 10px;
`;

const ButtonText = styled(BodyText)`
  margin-left: 12px;
`;

const NoLabel = styled.div`
  height: 18px;
  margin-top: 12px;
`;

const Label = styled.label`
  color: ${({ $textColor }) => $textColor};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
`;

const ErrorDiv = styled.div``;

const RadioButtonStyle = {
  ErrorDiv,
  Radio,
  RadioContainer,
  ButtonText,
  Flex,
  NoLabel,
  Label,
};

export default RadioButtonStyle;
